import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import drive from "../../Assets/Projects/MacauDriveExam.png";
import critical from "../../Assets/Projects/CriticalValue.png";
import finsmarket from "../../Assets/Projects/FinSMarketApp.png";
import bms from "../../Assets/Projects/BMS.png";
import fyp from "../../Assets/Projects/FYP.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={drive}
              isBlog={false}
              title="Macau Drive Exam"
              description="A mobile application dedicated to candidates preparing for the Macau Transport Bureau (DSAT) Driver's License Theory Exam. It features the latest and most comprehensive question bank. In order to help candidates pass the theory test smoothly and successfully. The application is built using React Native."
              demoLink="https://macaudrive.app/"
              appStoreLink="https://apps.apple.com/us/app/%E6%BE%B3%E9%96%80%E8%80%83%E8%BB%8A%E7%A5%9E%E5%99%A8/id6751081446"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={finsmarket}
              isBlog={false}
              title="FinSMarket App"
              description="A mobile application dedicated to investors seeking smarter, data-driven investment decisions. It features AI-powered stock analysis from multiple perspectives, including target price evaluation and sentiment tracking. The AI system help candidates make informed investment decisions efficiently. The application is built using React Native."
              demoLink="https://www.finsmarket.ai/zh-TW/mobile"
              appStoreLink="https://apps.apple.com/mo/app/finsmarket-ai-smart-investing/id6741387267"
              playStoreLink="https://play.google.com/store/apps/details?id=com.zentanet.finsmarket"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={critical}
              isBlog={false}
              title="Critical Value System"
              description="This project was developed during my university internship at a hospital. It involved extending the functionality of the Critical Value System. The original system was only implemented on desktop computers; however, we used Vue, C#, and Enterprise WeChat to add a mobile pathway to the system, allowing it to operate simultaneously with the desktop version."             
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fyp}
              isBlog={false}
              title="Final Year Project"
              description="This is my university graduation project: a Web-based Teaching Assistance System. The system is primarily implemented using Vue, SpringBoot, and MyBatis-Plus. The main innovation of this system lies in the paper-based test recognition feature within its In-Class Quiz Module."
              ghLink="https://github.com/BrianHKK/web-online-check"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bms}
              isBlog={false}
              title="Backend Management System"
              description="This project was a learning initiative I undertook during my university years, designed to teach me how to build and deploy a full-stack project from start to finish. It is a full-stack management system based on Vue.js and Spring Boot, featuring core functionalities such as user management, news management, and announcement management."
              ghLink="https://github.com/BrianHKK/backend-management-system"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
